import { Navigate } from 'react-router-dom';
import { Selector } from './Selector';
import { readLastWorkspace, WORKSPACE_PATH } from './workspace';

// Smart entry point. On / we check localStorage and either bounce the
// user to their last-used workspace (using `replace` so back doesn't
// land them here in a stale state) or show the Selector for a fresh visit.
//
// /select always renders Selector regardless of stored choice — that's
// how the "Switch workspace" link escapes the auto-redirect.
export function RootGate() {
  const last = readLastWorkspace();
  if (last) return <Navigate to={WORKSPACE_PATH[last]} replace />;
  return <Selector />;
}
